import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient.js";
import { getErrorMessage } from "#/utils/APIUtils.js";

const baseUrl = "/api/zival/identifikator";

const animalIdentifiersSlice = createSlice({
  name: "animalIdentifiers",
  initialState: {
    page: {},
    isLoading: false,
    error: null,
    byIdentifiersValue: {},
    isLoadingByIdentifierValue: {},
    errorByIdentifierValue: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // eslint-disable-next-line no-use-before-define
      .addCase(fetchAnimalIdentifiersPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      // eslint-disable-next-line no-use-before-define
      .addCase(fetchAnimalIdentifiersPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
        for (const record of action.payload.content) {
          if (!state.byIdentifiersValue) {
            state.byIdentifiersValue = {};
          }
          if (record?.vrednost) {
            state.byIdentifiersValue[record.vrednost] = record;
          }
        }
      })
      // eslint-disable-next-line no-use-before-define
      .addCase(fetchAnimalIdentifiersPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const fetchAnimalIdentifiersPage = createAsyncThunk(
  "animalIdentifiers/fetchPage",
  async ({ page, filter, sort } = {}, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false,
        true
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export default animalIdentifiersSlice.reducer;
